import styled from "@emotion/styled";
import React, { useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import Popover from "@mui/material/Popover";
import TabList from "@mui/lab/TabList";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FormLabel from "@mui/material/FormLabel";

import {
  Avatar,
  Box,
  ButtonGroup,
  Checkbox,
  Chip,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  Tab,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import CartItem from "./CartItem";
import { useSelector, useDispatch } from "react-redux";

import {
  addItem,
  addProduct,
  clearCart,
  removeItem,
  setDonationType,
  setSelectProductError,
} from "./slice";
import { debounce, result } from "lodash";
import { ComponentType, units } from "../../common/enum";
import SvgIconStyle from "../../components/SvgIconStyle";
import ConfirmDialog from "../../components/ConfirmDialog";
import { setConfirmationDialog } from "../AdminView/adminSlice";

const mainBoxStyles = { display: "flex", justifyContent: "space-between" };

const groupToIcon = {
  Frescos: "/static/icons/Icons/icon-frescos.png",
  Frutas: "/static/icons/Icons/icon-frescos.png",
  Congelados: "/static/icons/Icons/icon-congelados.png",
  Mercearia: "/static/icons/Icons/icon-mercearia.png",
  'Laticínios, cremes vegetais e ovos': '/static/icons/Icons/icon-lacticinios.png',
  Bebidas: "/static/icons/Icons/icon-bebidas.png",
  'Refeições prontas': "/static/icons/Icons/icon-refeicoesprontas.png"
};

const avataStyles = { bgcolor: "#E4F2E8", width: "58px", height: "58px" };

const svgIconStyle = { color: "black", width: "40px", height: "40px" };

const Products = ({ t }) => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    display: "flex",
    width: "100%",
    padding: "10px",
    position: "relative",
    alignContent: "center",
  }));
  // const [value, setValue] = useState(0);
  // const [filters, setFilters] = React.useState([{ productName: "" }]);
  const [results, setResults] = React.useState([]);
  const {
    donationCart: { products: items, donationType, productList, donationId ,selectProductError},
    adminDashboard: { confirmationDialog },
  } = useSelector((state) => state);
  const [displayed, setDisplayed] = React.useState(false);
  const dispatch = useDispatch();

  const [checkedEvent, setCheckedEvent] = React.useState(
    donationType === "event"
  );
  const [checked, setChecked] = React.useState(donationType === "donation");
  const [error , setError] = React.useState("")

  const handleClose = React.useCallback(() => {
    dispatch(setConfirmationDialog(false));
  }, [dispatch]);

  const onConfirm = React.useCallback(() => {
      for (const element of items) {
        const payload = {
          donationId: donationId,
          productId: element.productId,
          totalProductQuantity: 0,
          unit: units[element.unitIndex],
        };
        dispatch(addProduct(payload));
      }

      dispatch(clearCart());
      dispatch(setConfirmationDialog(false));
  }, [dispatch]);

  // const filterProducts = (list, params) => {
  //   let filteredList = list.filter((item) => item.productName !== null);
  //   let paramLen = 0;
  //   params.forEach((filter, i) => {
  //     const key = Object.keys(filter)[i];
  //     if (key.toString().length > 2) {
  //       paramLen = key.toString().length;
  //     }
  //     filteredList = filteredList.filter((item) => {
  //       const productVariable = item[key].toLowerCase();
  //       const searchVariable = filter[key].toLowerCase();
  //       return productVariable.startsWith(searchVariable);
  //     });
  //   });
  //   return paramLen > 2 ? filteredList : [];
  // };

  const filterProductList = React.useCallback((list, value) => {
    return list.filter(
      (item) =>
        (item.productName &&
          item.productName.toLowerCase().includes(value.toLowerCase())) ||
        item.productGroup.toLowerCase().includes(value.toLowerCase()) ||
        item.productType.toLowerCase().includes(value.toLowerCase())
    );
  }, []);
  
  
  const productGroups = productList.map(product => product.productGroup);
  const uniqueProductGroups = [...new Set(productGroups)];

  const filterProductList2 = React.useCallback((uniqueProductGroups) => {
    return uniqueProductGroups.filter(
      (item) =>
        (item)
    );
  }, []);

  const getcproductGroup = (productList) => {
    setTabValue(newValue);
  };
 
  const debouncedSearch = debounce(async (value) => {
    const myResult = await filterProductList(productList, value);
    if (value.length === 0) {
      setResults([]);
    } else {
      setResults(myResult);
    }
  }, 500);

  const searchFromStore = (e) => {
    e.preventDefault();
    // const params = filters;
    // params[0].productName = e.target.value.toString();
    const value = e.target.value.toString();
    // const newResults = filterProducts(productList, params);
    // setResults(newResults);
    debouncedSearch(value);
    // if (e.target.value.length === 0) {
    //   setResults([]);
    // }
  };

  React.useEffect(() => {
    if(items.length > 0){
      dispatch(setSelectProductError(false))
    }
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch,items,dispatch]);
  const [value, setValue] = React.useState("1"); 
  const handleChange = (event, newValue) => { 
    setValue(newValue); 
  }; 
  const [tabValue, setTabValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [subSubMenuAnchorEl, setSubSubMenuAnchorEl] = useState(null);
  const [selectedProductGroup, setSelectedProductGroup] = useState(null);
  const [selectedProductType, setSelectedProductType] = useState(null);
  const [currentTabName, setCurrentTabName] = useState(t("insertByBatch"));
  const [filteredProducts, setFilteredProducts] = useState([]);

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
   
  };
  const uniqueProductGroups2 = Array.from(new Set(productList.map(product => product.productGroup)));
  const uniqueProductTypes2 = Array.from(new Set(productList.map(product => product.productType)));

  const closeMenu = () => {
    setAnchorEl(null);
  };
 
  
  const openSubMenu = (event) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const closeSubMenu = () => {
    setSubMenuAnchorEl(null);
    setSelectedProductGroup(null);
    setSelectedProductType(null);
  };

  const [expandedGroup, setExpandedGroup] = useState(null);

  const handleExpandGroup = (event, productGroup) => {
    setExpandedGroup(productGroup);
    setSelectedProductGroup(productGroup);
    //setAnchorEl(event.currentTarget);
  };
  const handleOpenTypeMenu = (event, productType , productName , productGroup) => {
   
    setCurrentTabName(productType);
    if(productName != ""){
      var filtered = productList.filter(product => product.productType === productType && product.productGroup == productGroup);
    }else if(productGroup != "" && productName != ""){
      var filtered = productList.filter(product => product.productGroup === productType);
    }else if(productGroup == "" && productName == ""){
      var filtered = productList.filter(product => product.productGroup === productType);
    }else{
      var filtered = productList.filter(product => product.productType === productType && product.productGroup == productGroup);
    }
   
    setFilteredProducts(filtered);
    setSubMenuAnchorEl(null);
    setAnchorEl(null);
    setSelectedProductGroup(null);
    setSelectedProductType(null);
  };
  const uniqueProductTypes = Array.from(new Set(productList
    .filter(product => product.productGroup === expandedGroup  && product.productName != "")
    .map(product => product.productType)
  ));
  uniqueProductTypes.sort()
  uniqueProductGroups.sort()
  return (
    <>
      <Stack padding={"3%"} spacing={3}>
        <Typography variant={"h1"} style={{fontSize:"24px", fontWeight:"bold"}}>
          {t("createDonationHeading")}
        </Typography>
{/*         
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "column",
              lg: "row",
              xl: "row",
            },
            gap: "20px",
          }}
        >
          <Item
            sx={{
              border: checked ? "2px solid #198754" : "1px solid #dddddd",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
            onClick={() => {
              setChecked(true);
              setCheckedEvent(false);
              dispatch(setDonationType("donation"));
            }}
          >
            {checked && (
              <img
                src={"/static/selected.png"}
                alt="icon"
                style={{
                  width: "40px",
                  position: "absolute",
                  right: -1,
                  top: -1,
                }}
              />
            )}
            <img
              src="/static/dashboard/donate.svg"
              alt="donate"
              style={{ height: "30px" }}
            />
            <Box marginLeft={"10px"}>
              <Typography fontSize={"subheading"} fontWeight={"bold"}>
                {t("donate")}
              </Typography>
              <Typography fontSize={"subheading"}>
                {t("donateDescription")}
              </Typography>
            </Box>
          </Item>
          <Item
            sx={{
              border: checkedEvent ? "2px solid #198754" : "1px solid #dddddd",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
            onClick={() => {
              setCheckedEvent(true);
              setChecked(false);
              dispatch(setDonationType("event"));
            }}
          >
            {checkedEvent && (
              <img
                src={"/static/selected.png"}
                alt="icon"
                style={{
                  width: "40px",
                  position: "absolute",
                  right: -1,
                  top: -1,
                }}
              />
            )}
            <img
              src="/static/dashboard/calendar.png"
              alt="calendar"
              style={{ height: "30px" }}
            />
            <Box marginLeft={"10px"}>
              <Typography fontSize={"subheading"} fontWeight={"bold"}>
                {t("event")}
              </Typography>
              <Typography fontSize={"subheading"}>
              {t("eventSub")}
              </Typography>
            </Box>
          </Item>
        </Box> */}

        <Paper>
          <Box sx={{ width: "100%", typography: "body1", padding: "10px" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                
                <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                >
                  <Tab label={t("insertBySearch")} value="1" />
                  {/* <Tab label={t("insertByBatch")} value="2"  /> */}
                  <Tab value="2" 
                        onClick={openMenu} 
                        sx={{padding: "7px"}}
                        
                        label={
                          <div>
                            {currentTabName}<ArrowDropDownIcon sx={{color:"#37B34A"}} />
                           
                          </div>
                        }
                        
                  />
                </TabList>
              </Box>
              <TabPanel value="1">
                <Stack spacing={3} direction="row">
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    <TextField
                      icon
                      fullWidth
                      label={t("search")}
                      id="fullWidth"
                      onChange={(e) => {
                        searchFromStore(e);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {selectProductError && <Typography variant="body1" color="error">{t("selectProductError")}</Typography>}
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                        gap: "10px",
                        // maxHeight: "500px",
                        // overflow: "hidden",
                        // overflowY: "scroll",
                        marginTop: "10px",
                        paddingBottom: "10px",
                      }}
                    >
                      {results.length > 0 ? (
                        results.map((item, index) => {
                          return (
                            <CartItem
                              item={item}
                              t={t}
                              key={index}
                              component={ComponentType.PRODUCT}
                            />
                          );
                        })
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            mt: "5%",
                          }}
                        >
                          <Avatar sx={avataStyles}>
                            <SvgIconStyle
                              src="static/icons/icon-pesquisaproduto.svg"
                              sx={svgIconStyle}
                            />
                          </Avatar>
                          <Box sx={{ paddingLeft: "10px" }}>
                            <Typography sx={{ marginTop: "10px" }}>
                              Utilize o campo de pesquisa para localizar
                              produtos
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Box>{" "}
                </Stack>
              </TabPanel>
              <TabPanel value="2"><Stack spacing={3} direction="row">
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    
                    {selectProductError && <Typography variant="body1" color="error">{t("selectProductError")}</Typography>}
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                        gap: "10px",
                        // maxHeight: "500px",
                        // overflow: "hidden",
                        // overflowY: "scroll",
                        marginTop: "10px",
                        paddingBottom: "10px",
                      }}
                    >
                      {filteredProducts.length > 0 ? (
                        filteredProducts.map((item, index) => {
                          return (
                            <CartItem
                              item={item}
                              t={t}
                              key={index}
                              component={ComponentType.PRODUCT}
                            />
                          );
                        })
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            mt: "5%",
                          }}
                        >
                          <Avatar sx={avataStyles}>
                            <SvgIconStyle
                              src="static/icons/icon-pesquisaproduto.svg"
                              sx={svgIconStyle}
                            />
                          </Avatar>
                          <Box sx={{ paddingLeft: "10px" }}>
                            <Typography sx={{ marginTop: "10px" }}>
                              Utilize a dropdown para localizar produtos
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Box>{" "}
                </Stack></TabPanel>
            </TabContext>
          </Box>
        </Paper>
        
        <Popover
        
        open={Boolean(anchorEl)}
         anchorEl={anchorEl}
        onClose={closeMenu}
       className="popoverprodutos"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <FormLabel
          component="legend"
          sx={{ ml: "24px", mt: 1, textTransform: "uppercase",fontWeight:600,fontSize:"12px" }}
        >
          {"CATEGORIA"}
        </FormLabel>
        {uniqueProductGroups.map((productGroup, index) => {
        var filterproducttypeaarrow = productList.filter(product => product.productGroup === productGroup && product.productName != "");
      
        return (
          
          <div key={index}>
          
            <MenuItem
              sx={{marginLeft: "7px"}}
              className="menuItemSelected"
              onClick={(event) => {
                if (filterproducttypeaarrow.length > 0) {
                  handleOpenTypeMenu(event, productGroup, "" , "");
                } else {
                  handleOpenTypeMenu(event, productGroup, "" , "");
                }
              }}
              style={{
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: productGroup === selectedProductGroup ? '#e4f2e8' : 'white',
              }}
              //   onMouseLeave={(event) => {
              //   event.stopPropagation(); // Prevent event from bubbling
              //   closeSubMenu();
              // }}
              // onMouseOver={(event) =>  {  if (filterproducttypeaarrow.length > 0) {openSubMenu(event), handleExpandGroup(event, productGroup)}}}
            >
            <img style={{ paddingRight: "10px" }} src={groupToIcon[productGroup]} alt={productGroup} />
            {productGroup} {filterproducttypeaarrow.length > 0 && (
              <Typography
                className="labelTypografyProducts"
                
                onClick={(event) => {
                  if (filterproducttypeaarrow.length > 0) {
                    event.stopPropagation();
                    openSubMenu(event);
                    handleExpandGroup(event, productGroup);
                  }
                }}
                
                sx={{ color: "#37B34A", position: "absolute", right: 0 }}
              ><ArrowRightIcon/></Typography>
            )}
          </MenuItem>
            {/* <Button
              onClick={(e) => handleOpenGroupMenu(e, productGroup)}
            >
              {productGroup}
              {hasProductType && <img src={groupToIconPath[productGroup]} alt={productGroup} />}
            </Button> */}
          </div>
        );
      })}
      </Popover>
      <Popover
        open={Boolean(subMenuAnchorEl)}
        anchorEl={subMenuAnchorEl}
        onClose={closeSubMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
         <FormLabel
          component="legend"
          sx={{ ml: "24px", mt: 1, textTransform: "uppercase",fontWeight:600,fontSize:"12px" }}
        >
          {selectedProductGroup && "MAIS " + selectedProductGroup}
        </FormLabel>
          {uniqueProductTypes.sort((a, b) => a.localeCompare(b, 'pt')).map((productType, index) => (
            <MenuItem sx={{marginLeft: "7px"}} key={index} onClick={(e) => handleOpenTypeMenu(e, productType ,"", selectedProductGroup)}>
              {productType}
            </MenuItem>
          ))}
      </Popover>
      </Stack>
      {displayed && (
        <div >
          Text that will appear when you hover over the button.
        </div>
      )}
      <ConfirmDialog
        open={confirmationDialog}
        handleClose={handleClose}
        title={t("")}
        content={t("confirmationClearCart")}
        onConfirm={onConfirm}
        cancelButtonTitle={t("cancel")}
        confirmButtonTitle={t("confirm")}
      />
    </>
  );
};

export default Products;
